module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mt0 list-reset primary-list"
  }, _vm._l((_vm.data), function(item, idx) {
    return _c('li', {
      key: item.id,
      staticClass: "list-item flex my2"
    }, [_c('div', {
      staticClass: "primary-img col-4 overflow-hidden",
      attrs: {
        "data-ratio": "16/9"
      }
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.shift(item.o_pic_list[0])),
        expression: "shift(item.o_pic_list[0])"
      }],
      staticClass: "fit"
    })])]), _c('div', {
      staticClass: "primary-info col-8 px2 pb2 flex flex-column items-start justify-between"
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "mt0 mb1 item-title",
      attrs: {
        "title": item.title,
        "data-clamp": "3"
      }
    }, [_vm._v(_vm._s(item.title))])]), _c('p', {
      attrs: {
        "data-clamp": "3"
      }
    }, [_vm._v(_vm._s(item.summary))]), _c('div', {
      staticClass: "sub col-12"
    }, [_vm._v(_vm._s(item.pub_source)), _c('span', {
      staticClass: "px1"
    }, [_vm._v("|")]), _vm._v(_vm._s(_vm.formatUtc(item.pub_utc)))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-277a32ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailList.vue
// module id = 984
// module chunks = 1